export default __webpack_public_path__ + "static/media/VO_Leea_White.dc19757c.svg";